import type { BuildingId } from './types';
import type { Synergy } from './synergies';

// === MEDIEVAL SYNERGIES ===
// T2 boosts T1 at +10%, T3 boosts T2 at +8%

export const SYNERGIES_MEDIEVAL: readonly Synergy[] = [
  { source: 'med_guild_hall', target: 'med_forge', bonusPerLevel: 0.10 },
  { source: 'med_windmill', target: 'med_vineyard', bonusPerLevel: 0.10 },
  { source: 'med_monastery', target: 'med_chapel', bonusPerLevel: 0.10 },
  { source: 'med_university', target: 'med_scriptorium', bonusPerLevel: 0.10 },
  { source: 'med_royal_mint', target: 'med_guild_hall', bonusPerLevel: 0.08 },
  { source: 'med_storehouse', target: 'med_windmill', bonusPerLevel: 0.08 },
  { source: 'med_cathedral', target: 'med_monastery', bonusPerLevel: 0.08 },
  { source: 'med_observatory', target: 'med_university', bonusPerLevel: 0.08 },
];

// === RENAISSANCE (MODERN) SYNERGIES ===

export const SYNERGIES_MODERN: readonly Synergy[] = [
  { source: 'mod_trading_post', target: 'mod_bank', bonusPerLevel: 0.10 },
  { source: 'mod_greenhouse', target: 'mod_plantation', bonusPerLevel: 0.10 },
  { source: 'mod_seminary', target: 'mod_basilica', bonusPerLevel: 0.10 },
  { source: 'mod_printing_press', target: 'mod_laboratory', bonusPerLevel: 0.10 },
  { source: 'mod_merchant_fleet', target: 'mod_trading_post', bonusPerLevel: 0.08 },
  { source: 'mod_granary_royal', target: 'mod_greenhouse', bonusPerLevel: 0.08 },
  { source: 'mod_vatican_lib', target: 'mod_seminary', bonusPerLevel: 0.08 },
  { source: 'mod_academy_sci', target: 'mod_printing_press', bonusPerLevel: 0.08 },
];

// === INDUSTRIAL SYNERGIES ===

export const SYNERGIES_INDUSTRIAL: readonly Synergy[] = [
  { source: 'ind_stock_exchange', target: 'ind_factory', bonusPerLevel: 0.10 },
  { source: 'ind_refrigeration', target: 'ind_cannery', bonusPerLevel: 0.10 },
  { source: 'ind_mission', target: 'ind_revival_hall', bonusPerLevel: 0.10 },
  { source: 'ind_telegraph', target: 'ind_research_lab', bonusPerLevel: 0.10 },
  { source: 'ind_central_bank', target: 'ind_stock_exchange', bonusPerLevel: 0.08 },
  { source: 'ind_agri_corp', target: 'ind_refrigeration', bonusPerLevel: 0.08 },
  { source: 'ind_grand_temple', target: 'ind_mission', bonusPerLevel: 0.08 },
  { source: 'ind_patent_bureau', target: 'ind_telegraph', bonusPerLevel: 0.08 },
];

// === CONTEMPORARY SYNERGIES ===

export const SYNERGIES_CONTEMPORARY: readonly Synergy[] = [
  { source: 'con_hedge_fund', target: 'con_startup', bonusPerLevel: 0.10 },
  { source: 'con_food_lab', target: 'con_vertical_farm', bonusPerLevel: 0.10 },
  { source: 'con_meditation_app', target: 'con_megachurch', bonusPerLevel: 0.10 },
  { source: 'con_ai_lab', target: 'con_data_center', bonusPerLevel: 0.10 },
  { source: 'con_crypto_mine', target: 'con_hedge_fund', bonusPerLevel: 0.08 },
  { source: 'con_global_logistics', target: 'con_food_lab', bonusPerLevel: 0.08 },
  { source: 'con_spiritual_retreat', target: 'con_meditation_app', bonusPerLevel: 0.08 },
  { source: 'con_space_agency', target: 'con_ai_lab', bonusPerLevel: 0.08 },
];

// === FUTURE SYNERGIES ===

export const SYNERGIES_FUTURE: readonly Synergy[] = [
  { source: 'fut_dyson_collector', target: 'fut_quantum_trader', bonusPerLevel: 0.10 },
  { source: 'fut_nano_farm', target: 'fut_bio_synthesizer', bonusPerLevel: 0.10 },
  { source: 'fut_consciousness_hub', target: 'fut_neural_temple', bonusPerLevel: 0.10 },
  { source: 'fut_singularity_engine', target: 'fut_quantum_computer', bonusPerLevel: 0.10 },
  { source: 'fut_matter_printer', target: 'fut_dyson_collector', bonusPerLevel: 0.08 },
  { source: 'fut_orbital_garden', target: 'fut_nano_farm', bonusPerLevel: 0.08 },
  { source: 'fut_cosmic_oracle', target: 'fut_consciousness_hub', bonusPerLevel: 0.08 },
  { source: 'fut_nexus_archive', target: 'fut_singularity_engine', bonusPerLevel: 0.08 },
];

// === HELPER ===

export function getSynergiesByEra(eraId: string): readonly Synergy[] {
  switch (eraId) {
    case 'medieval':     return SYNERGIES_MEDIEVAL;
    case 'modern':       return SYNERGIES_MODERN;
    case 'industrial':   return SYNERGIES_INDUSTRIAL;
    case 'contemporary': return SYNERGIES_CONTEMPORARY;
    case 'future':       return SYNERGIES_FUTURE;
    default:             return [];
  }
}

export type { Synergy, BuildingId };
